$(window).on("scroll", function(){
    checkDesktopNav();
});

function checkDesktopNav(){
    if($("body").hasClass("desktop")){
        if($(window).scrollTop() >= 150){
            $(".header").css("padding-bottom", $(".js-header_desktop_nav").height() + "px");
            $(".js-header_desktop_nav").addClass("header_desktop_nav-fixed")
        }else{
            $(".header").css("padding-bottom", "0px");
            $(".js-header_desktop_nav").removeClass("header_desktop_nav-fixed")
        }
    }else{
        $(".header").css("padding-bottom", "0px");
        $(".js-header_desktop_nav").removeClass("header_desktop_nav-fixed")
    }
}

$(document).on("click", ".js-desktop_meta_sub", function(e){
    e.preventDefault();

    $(".js-desktop_meta_sub_con-" + $(this).data("parent")).slideToggle();
    $(this).toggleClass("header_desktop_nav_meta_list_item_link-active");
})

$(document).on("click keydown", ".js-desktop_meta_close", function(e){

    if(e.key !== "Enter" && e.key!== " " && e.type !== "click") return;
    e.preventDefault();
    $(".js-desktop_meta_sub").removeClass("header_desktop_nav_meta_list_item_link-active");
    $(".js-desktop_meta_sub_con-" + $(this).data("parent")).slideToggle();
})

toggleSub = true;

$(document).on("mouseenter", ".js-desktop_nav_sub", function(e){
    e.preventDefault();
    clearTimeout(toggleSub);
    if(!$(".js-desktop_nav_sub_con-" + $(this).data("parent")).is(":visible")){
        $(".js-desktop_nav_sub_con").hide();
        $(".js-desktop_nav_sub").removeClass("header_desktop_nav_list_item_link-active");
        $(".js-desktop_nav_sub_con_arrow").hide();
    }
    $(".js-desktop_nav_sub_con-" + $(this).data("parent")).slideDown(100);
    $(this).addClass("header_nav_item_link-active");
    $(this).find(".js-desktop_nav_sub_con_arrow").show();
}).on("mouseleave", ".js-desktop_nav_sub", function(){
    toggleSub = window.setTimeout(function(){
        closeNav();
    }, 10)
})

$(document).on("mouseenter", ".js-desktop_nav_sub_con", function(e){
    clearTimeout(toggleSub);
    $(this).show();
}).on("mouseleave", ".js-desktop_nav_sub_con", function(){
    toggleSub = window.setTimeout(function(){
        closeNav();
    }, 10)
})

function closeNav(){
    $(".js-desktop_nav_sub_con").slideUp(100);
    $(".js-desktop_nav_sub").removeClass("header_desktop_nav_list_item_link-active");
    $(".js-desktop_nav_sub_con_arrow").hide();
}